/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule extends models.ServiceAccountNativeDetailsBaseForCostCenterDimension {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule>): ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule(), model);
        ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule>): ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule.newInstance(<ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenterDimension.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Dimension Id
     */
    dimension_id: string;

    /**
     * Dimension Group Rule Id
     */
    grouping_rule_id: string;

}
